module.exports = __webpack_public_path__ + "img/overview23.af28b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/overview23.jpg
// module id = ul6Y
// module chunks = 0